export const selectMedicalData = (state) => state.medical.data;
export const selectMedicalHistory = (state) => state.medical.history;
export const selectSelectedRecord = (state) => state.medical.selectedRecord;
export const selectMedicalLoading = (state) => state.medical.loading;
export const selectHistoryLoading = (state) => state.medical.historyLoading;
export const selectMedicalError = (state) => state.medical.error;

// Sélecteur pour compter les enregistrements
export const selectMedicalRecordCount = (state) => state.medical.history.length;

// Sélecteur pour avoir les 5 derniers enregistrements
export const selectRecentRecords = (state) => state.medical.history.slice(0, 5);

// ✅ NEW — Assureurs
export const selectInsuranceProviders = (state) => state.medical.providers || [];
export const selectInsuranceProvidersLoading = (state) => state.medical.providersLoading;
export const selectInsuranceProvidersError = (state) => state.medical.providersError;

export const selectInsurancesSaving = (state) => state.medical.loading;
export const selectUserInsurances = (state) =>
  Array.isArray(state.medical.data?.insurance)
    ? state.medical.data.insurance
    : [];

